import * as React from "react"

const LineColor6 = React.forwardRef((props, pathRef) => {
        return (
            <svg
                width={2}
                height={55}
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                viewBox={`0 0 2 55`}


            >
                <path
                    id={"line-color-6"}
                    ref={pathRef}
                    d="M0 0V55H2V0H0Z" fill="#5FCCEF"
                    strokeDashoffset={props.normalizedPosition }
                    strokeDasharray={props.pathLength}
                />
            </svg>
        )
    }
)

export default LineColor6
